import StructuredDataApi from './StructuredDataApi';

// The in-app documentation registry (doc-277).
//
// This array IS the extensibility mechanism: adding a doc is one content file
// under frontend/src/docs/ plus one entry here — no new route, no new page, no
// backend, no table. Order here is the order the /docs index lists them in.
//
// Visibility: every signed-in user sees every doc (founder decision, doc-277 —
// each login is a Lightspark employee and none of this content is sensitive).
// If a genuinely sensitive doc ever lands, the place to add per-doc gating is a
// filter over this array in pages/Docs.js plus the same check in
// pages/DocPage.js — not a parallel permission scheme.
export const DOCS = [
  {
    slug: 'structured-data-api',
    title: 'Structured Data API',
    summary:
      'Pull AI-extracted contract data out of Docket with a service API key. Read-only, machine-auth, four endpoints.',
    Component: StructuredDataApi,
  },
];

export function findDoc(slug) {
  return DOCS.find((doc) => doc.slug === slug) || null;
}

export default DOCS;
